import React from "react";

export default function SamcreteSection() {
  return (
    <section className="p-5 grid grid-cols-1 md:grid-cols-2 md:items-center  justify-between m-auto md:px-0 md:w-[85%] w-full py-20 gap-5">
      <div className="w-full md:w-4/5">
        <span className="text-[#9A9A9A]">About</span>
        <h4 className="font-bold">Samcrete</h4>
        <p className=" mt-5 leading-relaxed">
       As a proud subsidiary of Samcrete Holding, H2A Medical Solutions draws strength and inspiration from its parent company’s legacy of excellence. H2A sees Samcrete as a leading example in the business world—an icon of innovation, resilience, and sustainable growth. Guided by this strong foundation, H2A is committed to following in its footsteps, striving to become a leading force in the medical industry while upholding the values and vision that define the Samcrete name.
        </p>
      </div>
      <div className="relative w-full h-full flex items-center p-48 justify-center">
        <img src={require("../../assets/About/Samcrete.png")} className="w-full h-full object-contain " alt="Samcrete Image"/>
      </div>
    </section>
  );
}
